import _toConsumableArray from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { addProduct, getProductDetail, updateProduct, getClassify, getSaleunit, getBrand, getSourcearea, getSpecDetailList } from '@/services/productDetail';
import { TreeSelect } from 'ant-design-vue';
import FooterToolBar from '@/components/tool/FooterToolBar';
var SHOW_PARENT = TreeSelect.SHOW_PARENT;
export default {
  name: 'basicParameter',
  i18n: require('../i18n-productDetail'),
  components: {
    TreeSelect: TreeSelect,
    FooterToolBar: FooterToolBar
  },
  props: ['productId'],
  data: function data() {
    var validatecategory = function validatecategory(rule, value, callback) {
      // let newData = _.cloneDeep(this.idsParam)
      // newData.splice(rule.field.split('.')[1],1)
      // if(newData.includes(value[value.length-1])) {
      // 	callback(new Error(this.$t('productDetail.alreadySelect')))
      // }
      callback();
    };
    return {
      initDatavalue: {
        specFlag: 2,
        //只有新建接口使用=》0：单规格 (一维规格) 1：多规格(二维规格) 2: 无规格。(该字段不允许修改)
        id: '',
        //商品id
        nameList: [],
        //商品名称list
        classifies: [],
        //商品分类id数组
        saleunit: undefined,
        //售卖单位
        brandId: undefined,
        //品牌
        sourceareaId: undefined,
        //原产地
        buyNotes: [],
        //购买说明
        addCartNotes: [] //加入购物车弹框提示内容
      },
      //初始化商品数据
      queryLoading: false,
      validatecategory: validatecategory,
      //基础数据
      datavalue: {
        specFlag: 2,
        //只有新建接口使用=》0：单规格 (一维规格) 1：多规格(二维规格) 2: 无规格。(该字段不允许修改)
        id: '',
        //商品id
        nameList: [],
        //商品名称list
        classifies: [],
        //商品分类id数组
        saleunit: undefined,
        //售卖单位
        brandId: undefined,
        //品牌
        sourceareaId: undefined,
        //原产地
        buyNotes: [],
        //购买说明
        addCartNotes: [] //加入购物车弹框提示内容
      },
      classifyList: [],
      saleunitList: [],
      brandList: [],
      sourceareaList: [],
      specFlagList: [{
        id: 2,
        name: this.$t('productDetail.specFlag2')
      }, {
        id: 0,
        name: this.$t('productDetail.specFlag0')
      }],
      //初始化的语言
      initialLangDataListForNameList: [],
      initialLangDataListForBuyNotes: [],
      initialLangDataListForAddCartNotes: [],
      errTip: this.$t('public.enterPlease'),
      errTipSelect: this.$t('public.pleaseSelect'),
      SHOW_PARENT: SHOW_PARENT,
      rules: {},
      flattenTreeList: [],
      classifiesOldLidt: [],
      idsParam: [],
      claIndex: null
    };
  },
  mounted: function mounted() {
    if (!this.$route.query.id) {
      this.datavalue.id = this.productId;
    }
    //获取商品id和规格类型
    if (this.$route.query.id) {
      this.datavalue.id = Number(this.$route.query.id); //新建时传这个
    } else if (this.$route.query.specFlag) {
      this.datavalue.specFlag = Number(this.$route.query.specFlag); //编辑时传这个
    }
    //			console.log(this.$route.query.specFlag)
    //			this.datavalue.id = Number("16");
    //			this.datavalue.specFlag = Number("2");
    //初始化
    this.getInitialLang();
    if (this.datavalue.id <= 0) {
      this.getInitialValue();
    }
  },
  created: function created() {},
  methods: {
    //初始化商品详情数据
    getInitialDetail: function getInitialDetail() {
      var _this = this;
      var self = this;
      self.queryLoading = true;
      getProductDetail(self.datavalue.id).then(function (res) {
        //				console.log(res.data)
        if (res.data.code == 200) {
          var rs = res.data.data;
          self.datavalue.specFlag = rs.specFlag;
          self.datavalue.id = rs.id;
          self.classifiesOldLidt = rs.classifies ? rs.classifies : [];
          self.datavalue.nameList = _.cloneDeep(self.initialLangDataListForNameList);
          self.datavalue.buyNotes = _.cloneDeep(self.initialLangDataListForBuyNotes);
          self.datavalue.addCartNotes = _.cloneDeep(self.initialLangDataListForAddCartNotes);
          // self.datavalue = {
          // 	specFlag: rs.specFlag,
          // 	id: rs.id,
          // 	classifies: rs.classifies,
          // 	nameList: _.cloneDeep(self.initialLangDataListForNameList),
          // 	buyNotes: _.cloneDeep(self.initialLangDataListForBuyNotes),
          // 	addCartNotes: _.cloneDeep(self.initialLangDataListForAddCartNotes)
          // };
          if (rs.saleunit > 0) {
            self.datavalue.saleunit = rs.saleunit;
          }
          if (rs.brandId > 0) {
            self.datavalue.brandId = rs.brandId;
          }
          if (rs.sourceareaId > 0) {
            self.datavalue.sourceareaId = rs.sourceareaId;
          }
          //传值
          self.$emit("getId", self.datavalue.id, rs.specFlag);
          //给多语言集合赋值
          rs.nameList.forEach(function (item, index) {
            self.datavalue.nameList.forEach(function (itemModal, index) {
              if (item.langId == itemModal.langId) {
                itemModal.name = item.name;
              }
            });
          });
          rs.buyNotes.forEach(function (item, index) {
            self.datavalue.buyNotes.forEach(function (itemModal, index) {
              if (item.langId == itemModal.langId) {
                itemModal.content = item.content;
              }
            });
          });
          rs.addCartNotes.forEach(function (item, index) {
            self.datavalue.addCartNotes.forEach(function (itemModal, index) {
              if (item.langId == itemModal.langId) {
                itemModal.content = item.content;
              }
            });
          });
          self.queryLoading = false;
          _this.getInitialValue();
        } else {
          self.$notification.error({
            message: res.data.message
          });
        }
      });
    },
    //初始化
    getInitialValue: function getInitialValue() {
      var _this2 = this;
      var self = this;
      self.queryLoading = true;
      var getObjClassify = {
        type: 1
      };
      getClassify(getObjClassify).then(function (res) {
        if (res.data.code == 200) {
          self.classifyList = res.data.data;
          //for (var i = 0; i < self.classifyList.length; i++) {
          //self.classifyList[i].disabled = true;
          //}
          if (self.datavalue.id > 0) {
            var treeData = _.cloneDeep(res.data.data);
            self.flattenTreeList = _this2.flattenTree(treeData);
            self.datavalue.classifies.push({
              value: self.findParentList(self.classifiesOldLidt[0]),
              key: self.classifiesOldLidt[0]
            });
            _this2.idsParam = _this2.datavalue.classifies.map(function (item) {
              return item.value[item.value.length - 1];
            });
            // this.isExist()
          } else {
            self.datavalue.classifies.push({
              value: [],
              key: Date.now()
            });
          }
          self.initDatavalue = _.cloneDeep(self.datavalue);
        } else {
          self.$notification.error({
            message: res.data.message
          });
        }
      });
      getSaleunit().then(function (res) {
        if (res.data.code == 200) {
          self.saleunitList = res.data.data;
        } else {
          self.$notification.error({
            message: res.data.message
          });
        }
      });
      var getObj = {
        statusType: !this.$route.query.id ? 1 : 2
      };
      getBrand(getObj).then(function (res) {
        if (res.data.code == 200) {
          self.brandList = res.data.data;
        } else {
          self.$notification.error({
            message: res.data.message
          });
        }
      });
      getSourcearea(getObj).then(function (res) {
        if (res.data.code == 200) {
          self.sourceareaList = res.data.data;
        } else {
          self.$notification.error({
            message: res.data.message
          });
        }
      });
      self.queryLoading = false;
      //				console.log(self.classifyList);
    },
    //获取localStorage里面的默认语言和系统设置中存的语言list
    getInitialLang: function getInitialLang() {
      var self = this;
      self.defaultLangObj = JSON.parse(localStorage.getItem('defaultLangObj'));
      self.langList = JSON.parse(localStorage.getItem('langList'));

      //处理商品名称
      var _iterator = _createForOfIteratorHelper(self.langList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var nameObj = {};
          //标题
          nameObj.titleName = self.$t('publicuse.goodsname') + '(' + item.langName + ')';
          //多语言id
          nameObj.langId = item.langId;
          //名称
          nameObj.name = "";
          if (item.langId == self.defaultLangObj.langId) {
            nameObj.required = true;
          } else {
            nameObj.required = false;
          }
          self.initialLangDataListForNameList.push(nameObj);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      self.datavalue.nameList = _.cloneDeep(self.initialLangDataListForNameList);

      //处理购买说明
      var _iterator2 = _createForOfIteratorHelper(self.langList),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _item = _step2.value;
          var _nameObj = {};
          //标题
          _nameObj.titleName = self.$t('productDetail.buyNotes');
          //多语言id
          _nameObj.langId = _item.langId;
          //名称
          _nameObj.content = "";
          self.initialLangDataListForBuyNotes.push(_nameObj);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      self.datavalue.buyNotes = _.cloneDeep(self.initialLangDataListForBuyNotes);

      //处理加入购物车弹框提示内容
      var _iterator3 = _createForOfIteratorHelper(self.langList),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _item2 = _step3.value;
          var _nameObj2 = {};
          //标题
          _nameObj2.titleName = self.$t('productDetail.addCartNotes') + '(' + _item2.langName + ')';
          //多语言id
          _nameObj2.langId = _item2.langId;
          //名称
          _nameObj2.content = "";
          self.initialLangDataListForAddCartNotes.push(_nameObj2);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      self.datavalue.addCartNotes = _.cloneDeep(self.initialLangDataListForAddCartNotes);
      if (self.datavalue.id > 0) {
        //初始化商品详情数据
        self.getInitialDetail();
      }
    },
    //保存
    saveData: function saveData() {
      var self = this;
      var newData = _.cloneDeep(self.datavalue);
      newData.classifies = this.idsParam;
      if (self.datavalue.id > 0) {
        //编辑
        self.$refs.datavalue.validate(function (valid) {
          if (valid) {
            // console.log(123)
            // let len = this.idsParam.length
            // let newLen = Array.from(new Set(this.idsParam)).length
            // if( len != newLen) {
            // 	this.$notification['error']({
            // 		message: this.$t('productDetail.alreadySelect'),
            // 	});
            // } else {
            //调接口
            self.queryLoading = true;
            updateProduct(newData).then(function (result) {
              if (result.data.code == 200) {
                self.initDatavalue = _.cloneDeep(self.datavalue);
                self.$message.success(self.$t('public.saveSuccessfully'));
                self.$emit("getId", self.datavalue.id, self.datavalue.specFlag);
              }
              self.queryLoading = false;
            }).finally(function () {
              self.queryLoading = false;
            });
            // }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      } else {
        //新建
        self.$refs.datavalue.validate(function (valid) {
          if (valid) {
            // let len = this.idsParam.length
            // let newLen = Array.from(new Set(this.idsParam)).length
            // if( len != newLen) {
            // 	this.$notification['error']({
            // 		message: this.$t('productDetail.alreadySelect'),
            // 	})
            // }  else {
            //调接口
            self.queryLoading = true;
            // let newData = self.datavalue;
            addProduct(newData).then(function (result) {
              if (result.data.code == 200) {
                self.datavalue.id = result.data.data;
                // self.$emit("getId", result.data.data);
                self.$emit("getId", self.datavalue.id, self.datavalue.specFlag);
                self.initDatavalue = self.datavalue;
                self.$message.success(self.$t('public.saveSuccessfully'));
              }
              self.queryLoading = false;
            }).finally(function () {
              self.queryLoading = false;
            });
            // }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    },
    check: function check() {
      if (JSON.stringify(this.initDatavalue) != JSON.stringify(this.datavalue)) {
        return false;
      } else {
        return true;
      }
    },
    // 子找父  先扁平化数组
    flattenTree: function flattenTree(treeData) {
      var result = [];
      function traverse(node) {
        if (node.childrenList && node.childrenList.length > 0) {
          var _iterator4 = _createForOfIteratorHelper(node.childrenList),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var child = _step4.value;
              traverse(child);
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
        delete node.childrenList;
        result.push(node);
      }
      var _iterator5 = _createForOfIteratorHelper(treeData),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var node = _step5.value;
          traverse(node);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      return result;
    },
    // 再通过这个数组去找到子节点相关的父节点
    findParentList: function findParentList(nodeId) {
      var ids = [nodeId];
      var child = this.flattenTreeList.find(function (item) {
        return item.id === nodeId;
      });
      while (child && child.parentId && child.parentId !== 0) {
        ids = [child.parentId].concat(_toConsumableArray(ids));
        child = this.flattenTreeList.find(function (item2) {
          return item2.id === child.parentId;
        });
      }
      return ids;
    },
    // 删除分类
    deleteCategory: function deleteCategory(index) {
      this.datavalue.classifies.splice(index, 1);
      this.idsParam = this.datavalue.classifies.map(function (item) {
        return item.value[item.value.length - 1];
      });
      // this.isExist()
    },
    changeCategory: function changeCategory(val) {
      console.log(val, 11122233);
      console.log(this.datavalue.classifies, 'clas.......');
      this.idsParam = this.datavalue.classifies.map(function (item) {
        return item.value[item.value.length - 1];
      });
      // if(!val) {
      // 	this.$refs.datavalue.validateField(['classifies.' + this.claIndex + '.value'])
      // }
      // this.isExist()
      // this.$forceUpdate() 
    },
    focusCas: function focusCas(index) {
      this.claIndex = index;
    },
    addtemplate: function addtemplate() {
      var temp = {
        value: [],
        key: Date.now()
      };
      this.datavalue.classifies.push(temp);
      // this.isExist()
    },
    isExist: function isExist() {
      var self = this;
      function alreadyExists(node) {
        if (node.childrenList && node.childrenList.length > 0) {
          var _iterator6 = _createForOfIteratorHelper(node.childrenList),
            _step6;
          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var child = _step6.value;
              alreadyExists(child);
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
        }
        if (self.idsParam.includes(node.id)) {
          node.disabled = true;
        } else {
          node.disabled = false;
        }
      }
      var _iterator7 = _createForOfIteratorHelper(this.classifyList),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var node = _step7.value;
          alreadyExists(node);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
  }
};